var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeletedDataset = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-datasets-90x90",
    xmlns: "http://www.w3.org/2000/svg",
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "boundary",
    width: 90,
    height: 90,
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    id: "icon_datasets_18x18",
    d: "M2.574,192.523V128.348h90v64.175Zm27.54-14.29H7.949v8.92H30.114Zm0-15.635H7.949v10.25H30.114Zm0-16.79H7.949v11.42H30.114Zm28.21,32.425H35.489v8.92H58.324Zm0-15.635H35.489v10.25H58.324Zm0-16.79H35.489v11.42H58.324ZM87.2,178.233H63.7v8.92H87.2Zm0-15.635H63.7v10.25H87.2Zm0-16.79H63.7v11.42H87.2Zm0-12.09H63.7v6.72H87.2Z",
    transform: "translate(-2.574 -115.435)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeletedDataset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleted-dataset.4396297be35833496f83bde29323d25c.svg";